import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field", "icon", "tooltip"]
  static values = { app: String, id: String }

  connect() {
    this.timeout = null
    this.tooltipTimeout = null
    this.lastCheckedValue = this.fieldTarget.value.trim()

    this.iconTarget.style.fontSize = "1.2em"

    this.fieldTarget.addEventListener("input", this.onInput.bind(this))
    this.fieldTarget.addEventListener("blur", this.onBlur.bind(this))

    this.iconTarget.addEventListener("mouseenter", () => {
      if (this.tooltipTarget.textContent) {
        this.tooltipTarget.style.display = "block"
      }
    })

    this.iconTarget.addEventListener("mouseleave", () => {
      this.tooltipTarget.style.display = "none"
    })
  }

  onInput() {
    clearTimeout(this.timeout)
    clearTimeout(this.tooltipTimeout)

    this.timeout = setTimeout(() => {
      this.checkClient(false)
    }, 400)
  }

  onBlur() {
    const currentVal = this.fieldTarget.value.trim()
    if (currentVal !== this.lastCheckedValue) {
      this.checkClient(true)
    } else {
      // disparition auto du tooltip après blur même si pas re-vérifié
      if (this.tooltipTarget.textContent) {
        this.tooltipTimeout = setTimeout(() => {
          this.tooltipTarget.style.display = "none"
        }, 2000)
      }
    }
  }

  checkClient(fromBlur = false) {
    const val = this.fieldTarget.value.trim()

    if (val.length < 1) {
      this.setNeutral()
      return
    }

    const regex = /\S+@\S+\.\S+/
    if (!regex.test(val)) {
      this.setError("Format invalide", fromBlur)
    } else {
      this.setLoading()
      this.callServer(val, fromBlur)
    }

    this.lastCheckedValue = val
  }

  callServer(email, fromBlur) {
    const appPath = this.appValue || ""
    const contactId = this.idValue || ""
    const url = `${appPath}/contacts_recrutements/verify_email?email=${encodeURIComponent(email)}${contactId ? `&id=${contactId}` : ""}`

    this.setLoading()
    fetch(url)
      .then(r => r.json())
      .then(json => this.handleServerResponse(json, fromBlur))
      .catch(() => this.setError("Erreur serveur", fromBlur))
  }

  handleServerResponse(res, fromBlur) {
    const msgs = []

    if (res.mx === false) msgs.push("MX record manquant")
    if (res.smtp === false) msgs.push("Email introuvable")
    if (res.regex === false) msgs.push("Format invalide")
    if (res.doublon === true) msgs.push("Email en doublon")

    if (res.valid && msgs.length === 0) {
      this.setSuccess("Adresse valide", fromBlur)
      this.dispatch("valid", { detail: { email: this.fieldTarget.value } })
    } else {
      this.setError(msgs.join(", "), fromBlur)
    }
  }

  setLoading() {
    clearTimeout(this.tooltipTimeout)
    this.iconTarget.className = "fa fa-spinner fa-spin"
    this.iconTarget.style.color = "#007bff"
    this.tooltipTarget.textContent = "Vérification en cours..."
    this.tooltipTarget.style.display = "block"
  }

  setSuccess(msg, fromBlur) {
    clearTimeout(this.tooltipTimeout)
    this.iconTarget.className = "fa fa-check-circle"
    this.iconTarget.style.color = "#28a745"
    this.tooltipTarget.textContent = msg
    this.tooltipTarget.style.display = "block"

    if (fromBlur) {
      this.tooltipTimeout = setTimeout(() => {
        this.tooltipTarget.style.display = "none"
      }, 2000)
    }
  }

  setError(msg, fromBlur) {
    clearTimeout(this.tooltipTimeout)
    this.iconTarget.className = "fa fa-exclamation-circle"
    this.iconTarget.style.color = "#dc3545"
    this.tooltipTarget.textContent = msg
    this.tooltipTarget.style.display = "block"

    if (fromBlur) {
      this.tooltipTimeout = setTimeout(() => {
        this.tooltipTarget.style.display = "none"
      }, 2000)
    }
  }

  setNeutral() {
    clearTimeout(this.tooltipTimeout)
    this.iconTarget.className = ""
    this.iconTarget.style.color = ""
    this.tooltipTarget.textContent = ""
    this.tooltipTarget.style.display = "none"
  }
}
